import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useSupplyIntakeSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionContainer: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
    },
    weekGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: theme.spacing(0.5),
    },
    dayCardGray: {
      padding: theme.spacing(0.5),
      backgroundColor: '#f5f5f5',
      borderRadius: theme.shape.borderRadius,
    },
    serviceName: {
      fontSize: '0.75rem',
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
    },
    dayContent: {
      minHeight: '25px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    serviceNameWithIcon: {
      lineHeight: 1,
      display: 'flex',
      alignItems: 'center',
      marginBottom: '-1px',
    },
    checkIcon: {
      color: '#4caf50',
    },
    closeIcon: {
      color: '#f44336',
    },
    highlightedCard: {
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: '4px solid #ff3700',
        borderRadius: theme.shape.borderRadius,
        pointerEvents: 'none',
        animation: '$pulse 2s ease-in-out infinite',
      },
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 1,
      },
      '50%': {
        opacity: 0.5,
      },
      '100%': {
        opacity: 1,
      },
    },
  }),
);
